import md5 from 'js-md5';
import DataStore from './store';

interface Data {
  [key: string]: string | number | Data | Boolean | Array<Data>
}

const store = DataStore.getInstance()

const whiteList = ['/api/account/social/check-auth']

export const getRandomCode = (length: number) => {
  if (length > 0) {
    const data = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z",
    ];
    let nums = "";
    for (let i = 0; i < length; i++) {
      const r = parseInt(Math.random() * 61 + "");
      nums += data[r];
    }
    return nums;
  } else {
    return "";
  }
}

const request = (url: string, config: RequestInit = {}, header: HeadersInit | Data = {}): Promise<Response> => {
  const tokenKey = store.get('token_key')
  const token = localStorage.getItem(tokenKey)
  
  const headers = {
    ...header,
    'Content-Type': 'application/x-www-form-urlencoded',
    'Authorization': ''
  }
  if(token) {
    headers['Authorization'] = `Bearer ${token}`
  }
  const realConfig: RequestInit = {
    headers,
    ...config,
  }
  
  return fetch(url, realConfig)
    .then((res: any) => {

      if(res.status === 200) {
        return res.json()
      }else if(res.status === 400 || res.status === 500 || res.status === 401){
        throw res.json()
      }else{
        throw res
      }
    })
    .then((resJson: any) => {
      return resJson
    })
    .catch(async (err) => {
      const res = await err
      throw res
    })
}

const getCommonParams = (data: Data) => {
  const client_id = store.get('client_id')
  const client_secret = store.get('client_secret')
  const obj: Data = {
    client_id: `${client_id}`,
    time: Math.floor((new Date()).getTime()/1000),
    nonce: getRandomCode(6),
    'X-UA': `OS=${navigator.platform}&LANG=${store.get('lang')}&PL=Web`
  }

  const params = {
    ...obj,
    ...data
  }

  // 加密获取sign
  const sign = md5(Object.keys(params).sort().map(key => `${key}=${params[key]}`).join('&') + client_secret)
  obj.sign = sign
  return obj
}
 
const connectUrl = (url: string, data: Data) => {
  const params = new URLSearchParams()
  Object.keys(data).forEach((key) => {
    params.append(key, `${data[key]}`)
  })
  return `${url}?${params.toString()}`
}

// GET请求
export const get = (url: string, data: Data = {}, header: HeadersInit | Data = {}): Promise<Response> => {
  data = {
    ...data,
    ...getCommonParams(data)
  }
  url = connectUrl(url, data)
  return request(url, { method: 'GET' }, header)
}

// POST请求
export const post = (url: string, data: Data = {}, header: HeadersInit | Data = {}): Promise<Response> => {
  url = connectUrl(url, getCommonParams(data))
  const params = new URLSearchParams()
  Object.keys(data).forEach((key) => {
    params.append(key, `${data[key]}`)
  })
  return request(url, {
    body: params.toString(),
    method: 'POST',
  }, header)
}
